import { render, staticRenderFns } from "./node-info-buttons.vue?vue&type=template&id=fe5186f0&scoped=true&"
import script from "./node-info-buttons.vue?vue&type=script&lang=ts&"
export * from "./node-info-buttons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5186f0",
  null
  
)

export default component.exports